var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';

var BooleanEditor = function BooleanEditor(_ref) {
  var value = _ref.value,
      field = _ref.field,
      onSelect = _ref.onSelect,
      onUpdate = _ref.onUpdate,
      props = _objectWithoutProperties(_ref, ["value", "field", "onSelect", "onUpdate"]);

  var handleChange = function handleChange(e) {
    onUpdate(field, null, true)(e.target.checked ? true : null, true);
  };
  var handleClear = function handleClear(e) {
    onUpdate(field, null, true)(null, true);
  };
  return React.createElement(
    React.Fragment,
    null,
    React.createElement("input", _extends({ type: "checkbox", onFocus: onSelect(field),
      onChange: handleChange,
      checked: value }, props))
  );
};
export { BooleanEditor };